import axios, { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const isAdminRequest = config.url?.startsWith('/admin/');

    let token;
    if (isAdminRequest) {
      token = localStorage.getItem('admin_token');
    } else {
      token = localStorage.getItem('token');
    }

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
      console.log(`Adding ${isAdminRequest ? 'admin' : 'user'} token to request:`, token.substring(0, 10) + '...');
    } else {
      console.log(`No ${isAdminRequest ? 'admin' : 'user'} token found in localStorage`);
    }
    return config;
  },
  (error: AxiosError): Promise<never> => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<never> => {
    console.error('Response error:', error);

    const isPasswordChangeRequest = error.config?.url?.includes('/change-password');
    const isLoginRequest = error.config?.url?.includes('/login');
    const isAdminRequest = error.config?.url?.startsWith('/admin/');

    if (error.response && error.response.status === 401 &&
        !isPasswordChangeRequest && !isLoginRequest) {

      if (isAdminRequest) {
        if (window.location.pathname !== '/admin') {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin');
          window.location.href = '/admin';
        }
      } else {
        if (window.location.pathname !== '/') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
